"use client";

import { useState } from "react";
import { trackEvent } from "@/lib/analytics/track";

export default function CopyPromptButton({ id, text }: { id: number; text: string }) {
  const [copied, setCopied] = useState(false);

  async function handleCopy() {
    try {
      await navigator.clipboard.writeText(text);
      trackEvent("copy_prompt_click", { promptId: id });
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
      fetch("https://www.nohaya.com/promptai/api/prompts/copy_count.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id }),
      }).catch(() => {});
    } catch {
      // Clipboard API unavailable — fail silently, the prompt text is still selectable on the page.
    }
  }

  return (
    <button
      onClick={handleCopy}
      className="flex items-center gap-2 rounded-full bg-gradient-to-r from-violet-600 to-fuchsia-600 px-5 py-2.5 text-sm font-semibold text-white shadow-md shadow-violet-500/30 transition hover:brightness-110"
    >
      {copied ? (
        <>
          <span aria-hidden="true">✓</span> Copied!
        </>
      ) : (
        <>
          <span aria-hidden="true">⧉</span> Copy Prompt
        </>
      )}
    </button>
  );
}
